// 45-B, paczka PP2 — podglad: zamiany terminow, kolejnosc jak w serii (C0, KONTRAKTY 2026-09-24).
// Poddrzewo `appCampaigns.p45.*`: ten plik edytuje TYLKO jego paczka; klucze PL i EN rownoczesnie.
// Teksty: MAPA 45-B „Teksty PL / EN” (order.*, move.*); zero zdan objasniajacych (regula 8).
export const appCampaignsP45 = {
  p45: {
    // Krok Edity: przelacznik segmentowy (regula 13), domyslnie „jak w serii” (D10).
    order: {
      label: 'Kolejność',
      series: 'jak w serii',
      random: 'losowa',
    },
    move: {
      action: 'Przenieś',
      swap: 'Zamień',
      chosen: 'Wybrany',
      confirm: 'Zamień terminy',
      // Pigulka przy niesionym poscie (ksztalt 43 C).
      carrying: 'przenosisz',
      // Czytnik: pasek niesionego posta i jego X.
      region: 'Przenoszony post',
      cancel: 'Wyjdź z przenoszenia',
      // Czytnik: uchwyt przeciagania na 1440.
      handle: 'Przeciągnij na inny post: {title}',
      // Wynik jako dana (toast klatki 04c).
      done: 'Zamieniono · {a} i {b}',
      // Powod, dla ktorego konto nie przyjmie terminu (szary cel, pigulka po 409 `slot_conflict`).
      reason: {
        limit: 'limit dnia',
        gap: 'za blisko',
        window: 'poza oknem konta',
        plan: 'poza planem',
      },
    },
  },
}
